import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseUrl) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let config = arguments.length > 2 ? arguments[2] : undefined;
  const instance = createAxiosClient({
    baseURL: baseUrl + "/",
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getAppointmentsByReference(referenceId, type) {
    return instance.post('appointments/search', {
      filter: {
        filters: [{
          property: 'type',
          value: type,
          type: 'eq'
        }, {
          property: 'referenceId',
          value: referenceId,
          type: 'eq'
        }]
      }
    });
  }

  function getLastAppointments(referenceId) {
    return instance.post('appointments/last', {
      referenceId: referenceId
    });
  }

  return {
    getAppointmentsByReference,
    getLastAppointments
  };
}